import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0.001, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease: [0.76, 0, 0.24, 1] } }),
};

export const MaskLines = ({ lines, className = "", delay = 0.2, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block" variants={lineVariants} custom={delay + i * 0.12}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
